<template>
  <fragment>
    <button
      ref="filterButton"
      class="btn top-block__filter"
      @click="showFilter"
    >
      <i class="material-icons">filter_list</i>
      Фильтр
    </button>
    <transition name="fade">
      <form
        v-show="isFilterShown"
        ref="filterForm"
        class="top-block__filter__block"
        @submit.prevent="applyFilters"
      >
        <div class="top-block__filter__block__wrapper">
          <div
            class="top-block__filter__block__wrapper__close"
            @click="hideFilter"
          >
            <button
              type="button"
              class="close"
            >
              <i class="material-icons">close</i>
            </button>
          </div>
          <div class="top-block__filter__block__deep mb-2">
            <label for="name">Дилер</label>
            <div class="input-group">
              <input
                id="name"
                v-model.trim="filters.name"
                class="form-control form-control-sm"
                placeholder="Поиск по дилеру"
              >
            </div>
          </div>
          <div class="top-block__filter__block__deep mb-2">
            <label for="UR">UR</label>
            <div class="input-group">
              <input
                id="UR"
                v-model.trim="filters.URCode"
                class="form-control form-control-sm"
                placeholder="Поиск по UR"
              >
            </div>
          </div>
          <div class="top-block__filter__block__deep align-items-baseline mb-2">
            <label for="isActive">Только активные</label>
            <div class="custom-control custom-checkbox">
              <input
                id="isActive"
                v-model="filters.isActive"
                type="checkbox"
                class="custom-control-input"
              >
              <label
                class="custom-control-label"
                for="isActive"
              />
            </div>
          </div>
          <div class="top-block__filter__block__deep footer">
            <button
              class="btn btn-secondary-ford-gray"
              type="button"
              @click="resetFilters"
            >
              Сбросить
            </button>
            <button
              class="btn btn-primary-ford-orange"
              type="submit"
            >
              <i class="material-icons">check</i>
              Применить
            </button>
          </div>
        </div>
      </form>
    </transition>
  </fragment>
</template>

<script>
export default {
  name: 'FilterDealers',
  data: () => ({
    isFilterShown: false,
    filters: {
      name: '',
      URCode: '',
      isActive: true,
    },
  }),
  watch: {
    filtersDealerRoles() {
      this.filters.role = this.filtersDealerRoles;
    },
  },
  methods: {
    showFilter() {
      this.isFilterShown = true;
      setTimeout(() => {
        document.addEventListener('click', this.handleOutsideClick);
      }, 0);
    },
    hideFilter() {
      this.isFilterShown = false;
      setTimeout(() => {
        document.removeEventListener('click', this.handleOutsideClick);
      }, 0);
    },
    getFilterProps() {
      const filter = { ...this.filters };

      // Back treat empty strings as "pattern", not "any value"
      // So we will not pass them
      ['name', 'URCode'].forEach((key) => {
        if (!filter[key]) {
          delete filter[key];
        }
      })
      return filter;
    },
    resetFilters() {
      Object.assign(this.$data.filters, this.$options.data().filters);
      this.$emit('applyFilters', this.getFilterProps());
      this.hideFilter();
    },
    applyFilters() {
      this.$emit('applyFilters', this.getFilterProps());
      this.hideFilter();
    },
    handleOutsideClick(evt) {
      const { filterForm, filterButton } = this.$refs;
      if (filterForm.contains(evt.target) || (filterButton.contains(evt.target) && !this.isFilterShown)) {
        return;
      }

      this.hideFilter();
    },
  },
};
</script>

<style>
.custom-checkbox {
  margin-right: 278px;
  transform: scale(1.2);
}
</style>
